import { Predicate } from "@siteimprove/alfa-predicate";
const { equals } = Predicate;
export function hasElement(elementOrPredicate) {
    let predicate;
    if (typeof elementOrPredicate === "function") {
        predicate = elementOrPredicate;
    }
    else {
        predicate = equals(elementOrPredicate);
    }
    return (cell) => predicate(cell.element);
}
//# sourceMappingURL=has-element.js.map